import { Activity, currentRequestTimeStamp } from "../../Constants";
import { buildBenchmarkLane, buildTransporterEntry } from "./spotLaneFormatter";

/**
 * Builds the list of lane objects from BenchmarkNow rspl data.
 *
 * Extracted from NewEnquiry.getBenchmarkData().
 * Caller is responsible for:
 *  - Calling toast.success("Please update your Terms and Conditions Before Submitting") if lanes > 0
 *  - Calling setsend_data() with the returned lanes
 *  - Calling settransporterlistempty(true) when hasEmptyTransporters is true
 *
 * @param {Array} rspl - Route/spot list passed in from BenchmarkNow.
 * @param {Array} tenure - The currently selected tenure option array.
 * @returns {{ lanes: Array, hasEmptyTransporters: boolean }}
 */

export const buildBenchmarkLanes = (rspl, tenure, email, userName) => {
  const lanes = [];
  let hasEmptyTransporters = false;

  if (!rspl || rspl.length === 0) {
    return { lanes, hasEmptyTransporters };
  }

  Activity([
    {
      screen: "LoRRI Spot",
      module: "New enquiry",
      user_activity: "New Enquiry screen visited",
      timestamp: currentRequestTimeStamp(),
      userEmail: email,
      userName: userName,
      companyname: email
              ? email.split("@")[1].split(".")[0]
              : "" 
    },
  ]);

  rspl.forEach((r) => {
    const transporterList = r?.value?.benchmarknow_analysis?.transporter_list;
    let brlist = [];

    if (Array.isArray(transporterList) && transporterList.length > 0) {
      brlist = transporterList.map((br) =>
        buildTransporterEntry(br, false),
      );
    } else {
      hasEmptyTransporters = true;
    }
    lanes.push(buildBenchmarkLane(r, tenure, brlist));
  });

  return { lanes, hasEmptyTransporters };
};
